import { AppDataLocalTax } from '@scts/app-data';
import { Accessibility, AdditionalItem } from '@scts-ui/component-library';
import {
  replaceDevLinkWithConfig,
  useTitleService,
} from '@scts/utilities';
import { useEffect, useState } from 'react';
import { STORAGE_ACCOUNT, FRONT_DOOR_URL } from '../../config';

const AccessibilityWrapper = () => {
  useTitleService('Accessibility Statement: Local Taxation Chamber');

  const [additionalItems, setAdditionalItems] = useState<AdditionalItem[]>();

  useEffect(() => {
    const newLinks = AppDataLocalTax.accessibility.additionalItems;
    newLinks.map((item) => {
      if (STORAGE_ACCOUNT && FRONT_DOOR_URL !== undefined) {
        if (item.url.toLocaleLowerCase().indexOf('ltcdv') !== -1) {
          item.url = replaceDevLinkWithConfig(
            FRONT_DOOR_URL,
            STORAGE_ACCOUNT,
            item.url
          );
        }
      }
    });

    setAdditionalItems(newLinks);
  }, [STORAGE_ACCOUNT, FRONT_DOOR_URL]);

  return (
    <Accessibility
      contactEmail={AppDataLocalTax.accessibility.contactEmail}
      complianceIssues={AppDataLocalTax.accessibility.complianceIssues}
      datePrepared={'01 April 2023'}
      additionalItems={additionalItems}
    />
  );
};

export default AccessibilityWrapper;
